import { OFFICIAL_EMAIL, TECHNICIAN_NAME_EN, TECHNICIAN_NAME_HE, SERVICE_LANGUAGES } from "../data/officialIdentity.js";
/** Keep public structured data within the confirmed service-business policy. */
export function publishedSchema(value) {
  if (Array.isArray(value)) return value.map(publishedSchema);
  if (!value || typeof value !== "object") return value;
  const out = {};
  for (const [key, child] of Object.entries(value)) {
    if (["price", "priceRange", "priceCurrency", "offers", "aggregateRating"].includes(key)) continue;
    if (key === "areaServed") {
      const names = (Array.isArray(child) ? child : [child]).map(area => typeof area === "string" ? area : area?.name).filter(Boolean);
      out[key] = Array.isArray(child) ? names : names[0];
    } else if (key === "@type" && child === "Product") {
      out[key] = "Service";
    } else {
      out[key] = publishedSchema(child);
    }
  }
  if (out["@type"] === "LocalBusiness" && (out.name?.includes("O-FIX") || out.name?.includes("אופיקס") || out["@id"]?.endsWith("/#business"))) {
    out.email = OFFICIAL_EMAIL;
    out.founder = { "@type": "Person", name: TECHNICIAN_NAME_EN, alternateName: TECHNICIAN_NAME_HE };
    out.contactPoint = { "@type": "ContactPoint", contactType: "customer service", telephone: "+972585449992", email: OFFICIAL_EMAIL, availableLanguage: SERVICE_LANGUAGES };
  }
  return out;
}